import React from "react";
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Suggestion from "./Suggestion";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from 'moment';

import {getSuggestions} from "./utils";

import Button from "react-bootstrap/esm/Button";
// import Form from 'react-bootstrap/Form';
class ReminderComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {  reminderTime: this.props.reminderTime, showSpinner: false,
			showSuggestedDateModal:true,suggestedDate:"",suggestedDates:undefined };
		//this.addReminder = this.addReminder.bind(this);
		this.changeTime = this.changeTime.bind(this);
		this.changeEndTime = this.changeEndTime.bind(this);
		this.clearEndTimeOnFocus = this.clearEndTimeOnFocus.bind(this);
		this.setEndTimeAsEndOfWeek = this.setEndTimeAsEndOfWeek.bind(this);
		this.setEndTimeAsEndOfNextWeek = this.setEndTimeAsEndOfNextWeek.bind(this);
		this.setEndTimeAsEndOfMonth = this.setEndTimeAsEndOfMonth.bind(this);
		this.getSuggestedTimeTime = this.getSuggestedTimeTime.bind(this);
		this.chooseSelectedTime = this.chooseSelectedTime.bind(this);
		this.reschedule = this.reschedule.bind(this);

		this.selectRadioSuggestion = this.selectRadioSuggestion.bind(this);
		this.getProgressBarType = this.getProgressBarType.bind(this);
		this.getFormattedDate = this.getFormattedDate.bind(this);
		this.getDayOfWeek = this.getDayOfWeek.bind(this);
		this.getSuggestionForDate = this.getSuggestionForDate.bind(this);
	}
	getFormattedDate(time){
		const suggestedTime = moment(time,"DD-MMM-YYYY HH:mm")
return  suggestedTime.format("DD-MMM")
	}
	handleReminderTypeChange(reminderType){
		this.setState({ reminderType: reminderType});
	}
	getDayOfWeek(time){
		const suggestedTime = moment(time,"DD-MMM-YYYY HH:mm")
return  suggestedTime.format("dddd")
	}
	getProgressBarType(value){
		if(value>100){
			return "danger"
		}else if(value>70)
		return "warning";
		else
		return "success";
	}
	selectRadioSuggestion(value){
		this.setState({ suggestedDate: value,showSuggestedDateModal: true });
		this.props.onChangeTime(value);
	}
	changeEndTime(event) {
		this.props.changeEndTime(event.target.value);
	}
	clearEndTimeOnFocus(event) {
		if (this.props.reminderEndTime) {
			this.props.changeEndTime("");
		}
	}
	setEndTimeAsEndOfWeek(event) {
		var now = moment().weekday(6);
		this.props.changeEndTime(now.format("DD-MMM-yyyy"));		
	}
	setEndTimeAsEndOfNextWeek(event) {
		var now = moment().weekday(7).weekday(6);
		this.props.changeEndTime(now.format("DD-MMM-yyyy"));			
	}
	setEndTimeAsEndOfMonth(event) {
		var now = moment().endOf('month');
		this.props.changeEndTime(now.format("DD-MMM-yyyy"));	
	}
	changeTime(value) {
		const formatted = moment.isMoment(value) ? value.format("DD-MMM-YYYY HH:mm") : value;
		this.props.onChangeTime(formatted);
	}
	reschedule() {
		this.props.reschedule();
	}
	chooseSelectedTime(){
		this.setState({ showSuggestedDateModal: true });
		if(this.state.suggestedDate){
			this.props.onChangeTime(this.state.suggestedDate);
		}
	}
	async getSuggestionForDate(id,date){
		var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
		var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
		var month = [];
		month[0] = "Jan";
		month[1] = "Feb";
		month[2] = "Mar";
		month[3] = "Apr";
		month[4] = "May";
		month[5] = "Jun";
		month[6] = "Jul";
		month[7] = "Aug";
		month[8] = "Sep";
		month[9] = "Oct";
		month[10] = "Nov";
		month[11] = "Dec";
		let month2 = ("0" + (date.getMonth()+1)).slice(-2)
		const formattedDate = date.getFullYear() + "-" + month2 + "-" + ("0" + date.getDate()).slice(-2)
		
		getSuggestions(id,0,formattedDate)
		.then(res=>{
			const suggestions =  res.suggestions
			if(suggestions!==undefined && suggestions.length>0){
				this.props.onChangeTime(suggestions[0].time);
			}else{
				const fo =  ("0" + date.getDate()).slice(-2) + "-" + month[date.getMonth()] + "-" + date.getFullYear() + " " + hours + ":" + minutes
				this.props.onChangeTime(fo);
			}
		})
		
		
		
	}
	getSuggestedTimeTime(event) {
		var date = new Date();
		if (event.target.name === 'TODAY') {
			date = new Date(new Date().getTime() + (60 * 60 * 1000));
			this.getSuggestionForDate(this.props.currentItem.id,date)
		} else if (event.target.name === 'TOMORROW') {
			date = new Date(new Date().getTime() + (1 * 24 * 60 * 60 * 1000));
			this.getSuggestionForDate(this.props.currentItem.id,date)
		} else if (event.target.name === 'NEXT_WEEK') {
			date = new Date(new Date().getTime() + (7 * 24 * 60 * 60 * 1000));
			this.getSuggestionForDate(this.props.currentItem.id,date)
		} else if (event.target.name === 'THIS_WEEKEND') {
			var now = new Date();
			const diff = 6 - now.getDay()
			date = new Date(new Date().getTime() + (diff * 24 * 60 * 60 * 1000));
			this.getSuggestionForDate(this.props.currentItem.id,date)
		}else if (event.target.name === 'NEXT_SUNDAY') {
			const now = new Date();
			const diff = 7 - now.getDay()
			date = new Date(new Date().getTime() + (diff * 24 * 60 * 60 * 1000));
			this.getSuggestionForDate(this.props.currentItem.id,date)
		}else if (event.target.name === 'NEXT_MONDAY') {
			const now = new Date();
			const diff = 8 - now.getDay()
			date = new Date(new Date().getTime() + (diff * 24 * 60 * 60 * 1000));
			this.getSuggestionForDate(this.props.currentItem.id,date)
		}
		else if (event.target.name === 'GET_SUGGESTION') {
		
			this.setState({ showSuggestedDateModal:true});
			
			//date= new Date(new Date().getTime() + (7 * 24 * 60 * 60 * 1000));
		}


		//alert('got clik')
		//this.props.onChangeTime(event);
		//	this.setState({reminderTime: event.target.value});
	}

	render() {
		var t = this.props.reminderTime;
		return <div>
			{this.state.showSuggestedDateModal && <Suggestion currentItem={this.props.currentItem} currentPriority={this.props.currentPriority} currentEffort={this.props.currentEffort} currentArea={this.props.currentArea} getProgressBarType={this.getProgressBarType} selectRadioSuggestion={this.selectRadioSuggestion} chooseSelectedTime={this.chooseSelectedTime} />}

			<Form.Group className="mb-3">
				<Form.Label><i className="bi bi-clock me-1"></i>Reminder date</Form.Label>
				{this.props.reminderType === 'AUTO'
					? <Form.Control placeholder="dd-MMM-yyyy HH:mm" value={t || ''} disabled readOnly />
					: <Datetime dateFormat="DD-MMM-YYYY" timeFormat="HH:mm" value={t} onChange={this.changeTime} closeOnSelect inputProps={{ placeholder: 'dd-MMM-yyyy HH:mm' }} />
				}
			</Form.Group>

			{this.props.reminderType === 'AUTO' &&
				<Form.Group className="mb-3">
					<Form.Label><i className="bi bi-calendar-check me-1"></i>End date</Form.Label>
					<div className="d-flex gap-2 align-items-center flex-wrap">
						<Form.Control placeholder="dd-MM-yyyy" onChange={this.changeEndTime} onFocus={this.clearEndTimeOnFocus} value={this.props.reminderEndTime || ''} style={{ maxWidth: '200px' }} />
						<Button onClick={this.setEndTimeAsEndOfWeek} variant="outline-secondary" size="sm"><i className="bi bi-calendar-week me-1"></i>Week</Button>
						<Button onClick={this.setEndTimeAsEndOfNextWeek} variant="outline-secondary" size="sm"><i className="bi bi-calendar-plus me-1"></i>Next Week</Button>
						<Button onClick={this.setEndTimeAsEndOfMonth} variant="outline-secondary" size="sm"><i className="bi bi-calendar-month me-1"></i>Month</Button>
					</div>
				</Form.Group>
			}

			<Form.Group className="mb-3">
				<div className="d-flex gap-3">
					<Form.Check inline checked={this.props.reminderType === 'AUTO'} onChange={this.props.onReminderTypeChange} label="Auto" value={this.props.reminderType} name="AUTO" type="radio" id="auto" />
					<Form.Check inline label="Manual" checked={this.props.reminderType === 'FIXED'} onChange={this.props.onReminderTypeChange} name="FIXED" type="radio" id="manual" />
					<Form.Check inline disabled value={this.props.reminderType} name="CRON" onClick={this.props.onReminderTypeChange} label="Recurring" type="radio" id="recurring" />
				</div>
			</Form.Group>

			{this.props.reminderType === 'FIXED' &&
				<div className="d-flex gap-2 align-items-center flex-wrap">
					<Button name="GET_SUGGESTION" onClick={this.getSuggestedTimeTime}>Suggest</Button>
					{this.state.showSpinner && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
					<Button name="TODAY" variant="outline-secondary" size="sm" onClick={this.getSuggestedTimeTime}>Today</Button>
					<Button name="TOMORROW" variant="outline-secondary" size="sm" onClick={this.getSuggestedTimeTime}>Tomorrow</Button>
					{this.props.currentArea === "PERSONAL" && <>
						<Button name="THIS_WEEKEND" variant="outline-secondary" size="sm" onClick={this.getSuggestedTimeTime}>This Sat</Button>
						<Button name="NEXT_SUNDAY" variant="outline-secondary" size="sm" onClick={this.getSuggestedTimeTime}>Next Sun</Button>
					</>}
					{this.props.currentArea === "WORK" &&
						<Button name="NEXT_MONDAY" variant="outline-secondary" size="sm" onClick={this.getSuggestedTimeTime}>Next Mon</Button>
					}
				</div>
			}

			<div className="mt-3">
				<Button variant="primary" title="Saves your changes — in Auto mode the date is cleared so a new one is scheduled" onClick={this.reschedule}><i className="bi bi-arrow-repeat me-1"></i>{this.props.saving ? 'Rescheduling...' : 'Reschedule'}</Button>
			</div>
		</div>
	}
}
export default ReminderComponent;
